<!--  -->
<template>
  <div id="index">
    <div id="header" class="header fn-clear opacity">
      <div class="centerline">
        <a href class="logo fl">
          <img src="./../assets/images/footer_logo@2x.png" alt />
        </a>
        <router-link to="/apply" class="into fr">申报查询入口</router-link>
        <div class="tab fr btn-group" v-show="menu==true">
          <router-link to="/home" class="btn sure">首页</router-link>
          <router-link to="/guide" class="btn">申请指南</router-link>
          <router-link to="/way" class="btn">管理办法</router-link>
          <router-link to="/question" class="btn">常见问题</router-link>
          <router-link to="/news" class="btn">新闻</router-link>
        </div>
        <a href="javascript:;" class="morebtn" @click="changemenu()">
          <img v-show="menu==false" src="./../assets/images/mobile/-e-nav_btn_menu@2x.png" alt />
          <img v-show="menu==true" src="./../assets/images/mobile/-e-nav_btn_close@2x.png" alt />
        </a>
      </div>
    </div>
    <div class="bar">
      <div class="con">
        <h2>科学和医学公共传播“基石奖”</h2>
        <p class="desc">
          The Fundamental Prize for Excellent Public Communication
          <br />in Science and Medicine
        </p>
        <img class="barline" src="./../assets/images/-e-js_con_line@2x.png" alt />
      </div>
    </div>
    <div class="conbox">
      <!-- 视频播放 -->
      <div class="vediobox">
        <div class="video convedio" :class="{'show':this.vedio=='hide'}" id="sponsor-video-one"></div>
        <div class="video-img" :class="{'vedioimg1':this.vedio=='show'}" @click="open()">
          <img src="./../assets/images/-e-review_btn_play@2x.png" alt />
        </div>
      </div>
      <div class="tit">
        <p class="title">基石奖定位</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="box1 fn-clear">
        <div class="fl con1">
          <div class="main">
            <img class="png1" src="./../assets/images/-e-location_title_decorate@2x.png" alt />
            <p class="tit">奖项宗旨</p>
            <img class="png2" src="./../assets/images/-e-location_js@2x.png" alt />

            <p class="desc">科学和医学公共传播“基石奖”旨在奖励那些透过公共媒介开展相关知识的普及、传播、教育、培训，而对科学与医学领域做出杰出贡献的个人或民间机构。</p>
          </div>
        </div>
        <div class="fr con2">
          <img class="png1" src="./../assets/images/-e-location_title_decorate@2x.png" alt />
          <p class="tit">奖项设置</p>
          <div class="main fl conmain">
            <img class="png2" src="./../assets/images/-e-location_01@2x.png" alt />
            <p class="tit">
              年度人物奖
              <span>1</span> 人
            </p>
            <p class="mainline"></p>
            <p class="desc">旨在奖励本年度内，利用专业知识，积极开展科学和医学知识和技能的普及、传播、教育、培训，而对科学与医学领域做出重要杰出贡献的个人。</p>
          </div>
          <div class="main fl conmain2">
            <img class="png3" src="./../assets/images/location_02@2x.png" alt />
            <p class="tit">
              年度贡献奖
              <span>3</span> 人
            </p>
            <p class="mainline"></p>
            <p class="desc">旨在奖励本年度内，积极参与科学和医学的公共传播，并展现出巨大潜力的博士学位前的下一代科学家和医生，包括研究生、大学生和中学生。</p>
          </div>
        </div>
      </div>
      <div class="tit">
        <p class="title">评审委员会</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="zljg">
        <!-- 人物切换 -->
        <div id="personal">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_01@2x.png" alt />
                  <p class="name">韩启德</p>
                  <p class="pline"></p>
                  <p
                    class="desc"
                  >中国科学技术协会名誉主席，第十一、十二、十三届九三学社中央委员会主席，第十、十一届全国人大常委会副委员长、第十二届政协全国委员会副主席</p>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_02@2x.png" alt />
                  <p class="name">饶毅</p>
                  <p class="pline"></p>
                  <p class="desc">首都医科大学校长，北京大学讲席教授，北大麦戈文研究所创始所长，北大-清华生命科学联合中心创始主任，北京脑科学中心创始主任</p>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_03@2x.png" alt />
                  <p class="name">王立铭</p>
                  <p class="pline"></p>
                  <p class="desc">浙江大学生命科学研究院教授、研究员、博士生导师</p>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_04@2x.png" alt />
                  <p class="name">陈宇翱</p>
                  <p class="pline"></p>
                  <p class="desc">中国科学技术大学教授、博士生导师</p>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_05@2x.png" alt />
                  <p class="name">郑永春</p>
                  <p class="pline"></p>
                  <p class="desc">中国科学院国家天文台研究员、青年科学家社会责任联盟理事长</p>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_06@2x.png" alt />
                  <p class="name">贾鹤鹏</p>
                  <p class="pline"></p>
                  <p class="desc">
                    苏州大学传媒学院教授
                    <br />康奈尔大学科学传播专业博士
                  </p>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination"></div>
          </div>
          <div class="swiper-container2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_01@2x.png" alt />
                  <p class="name">韩启德</p>
                  <p class="pline"></p>
                  <p class="desc">
                    中国科学技术协会名誉主席，第十一、十二…
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">韩启德</p>
                    <p class="pline"></p>
                    <p
                      class="desc"
                    >中国科学技术协会名誉主席，第十一、十二、十三届九三学社中央委员会主席，第十、十一届全国人大常委会副委员长、第十二届政协全国委员会副主席</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_02@2x.png" alt />
                  <p class="name">饶毅</p>
                  <p class="pline"></p>
                  <p class="desc">
                    首都医科大学校长，北京大学讲席教授，北...
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">饶毅</p>
                    <p class="pline"></p>
                    <p class="desc">首都医科大学校长，北京大学讲席教授，北大麦戈文研究所创始所长，北大-清华生命科学联合中心创始主任，北京脑科学中心创始主任</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_03@2x.png" alt />
                  <p class="name">王立铭</p>
                  <p class="pline"></p>
                  <p class="desc">
                    浙江大学生命科学研究院教授、研究员、博...
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">王立铭</p>
                    <p class="pline"></p>
                    <p class="desc">浙江大学生命科学研究院教授、研究员、博士生导师</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_04@2x.png" alt />
                  <p class="name">陈宇翱</p>
                  <p class="pline"></p>
                  <p class="desc">
                    中国科学技术大学教授、博士生..
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">陈宇翱</p>
                    <p class="pline"></p>
                    <p class="desc">中国科学技术大学教授、博士生导师</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
              </div>
              <div class="swiper-slide">
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_05@2x.png" alt />
                  <p class="name">郑永春</p>
                  <p class="pline"></p>
                  <p class="desc">
                    中国科学院国家天文台研究员、青年科学家社会责任...
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">郑永春</p>
                    <p class="pline"></p>
                    <p class="desc">中国科学院国家天文台研究员、青年科学家社会责任联盟理事长</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
                <div class="con">
                  <img class="png" src="./../assets/images/-e-photo_06@2x.png" alt />
                  <p class="name">贾鹤鹏</p>
                  <p class="pline"></p>
                  <p class="desc">
                    苏州大学传媒学院教授...
                    <a href="javascript:;" class="up"></a>
                  </p>
                  <div class="tiptxt">
                    <p class="name">贾鹤鹏</p>
                    <p class="pline"></p>
                    <p class="desc">苏州大学传媒学院教授 康奈尔大学科学传播专业博士</p>
                    <a href="javascript:;" class="down"></a>
                  </div>
                </div>
              </div>
            </div>
            <!-- 如果需要分页器 -->
            <div class="swiper-pagination swiper-pagination2"></div>
          </div>
        </div>
        <div class="tit">
          <p class="title">治理结构</p>
          <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
        </div>
        <div class="jg"></div>
      </div>

      <div class="tit">
        <p class="title">捐赠人</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="juanzeng">
        <div class="btn-group">
          <div class="btn">
            <p class="tit">捐赠：</p>
            <p class="sum">
              <span>50</span>万元
            </p>
            <p class="desc">饶毅、董建瑾夫妇</p>
            <p class="btnline">
              <span></span>
            </p>
          </div>
          <!-- <div class="btn">
            <p class="tit">拟募捐：</p>
            <p class="sum">
              <span>100</span>万元
            </p>
            <p class="desc">平台方，同时匹配平台运营资源</p>
            <p class="btnline"></p>
          </div>-->
          <div class="btn">
            <p class="tit">捐赠：</p>
            <p class="sum">
              <span>50</span>万元
            </p>
            <p class="desc">王立铭、沈玥夫妇</p>
            <p class="btnline">
              <span></span>
            </p>
          </div>
        </div>
      </div>
      <div class="tit">
        <p class="title">奖项时间安排</p>
        <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
      </div>
      <div class="timebox">
        <div class="timeborder">
          <div class="timeborder-mrg">
            <div class="timeline-line">
              <i class="timeline-line-mask"></i>
              <i class="timeline-dot d1"></i>
              <i class="timeline-dot d2"></i>
              <i class="timeline-dot d3"></i>
              <i class="timeline-dot d4"></i>
              <i class="timeline-dot d5"></i>
            </div>
            <ul class="timeline-list">
              <li class="timeline-item t1">
                <span class="timeline-item-dot"></span>
                <span class="timeline-m">05月</span>
                <span class="timeline-name">奖项筹备</span>
              </li>
              <li class="timeline-item t2">
                <span class="timeline-item-dot"></span>
                <span class="timeline-m">08月</span>
                <span class="timeline-name">提名申报</span>
              </li>
              <li class="timeline-item t3">
                <span class="timeline-item-dot"></span>
                <span class="timeline-m">09月</span>
                <span class="timeline-name">奖项初审</span>
              </li>
              <li class="timeline-item t4">
                <span class="timeline-item-dot"></span>
                <span class="timeline-m">10月</span>
                <span class="timeline-name">奖项终审</span>
              </li>
              <li class="timeline-item t5">
                <span class="timeline-item-dot"></span>
                <span class="timeline-m">12月</span>
                <span class="timeline-name">颁奖典礼</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="zbfjs">
        <div class="tit">
          <p class="title">主办方介绍</p>
          <img class="titline" src="./../assets/images/-e-js_title_line@2x.png" alt />
        </div>
        <div class="introduce">
          <div class="main fn-clear">
            <div class="png fl">
              <img src="./../assets/images/-e-unit_zsfz@2x.png" alt />
            </div>
            <div class="contxt fl">
              <p>
                “知识分子”(the-intellectual) 2015年9月18日上线，由三位知名学者——北京大学教授饶毅、清华大学教授鲁白、普林斯顿大学教授谢宇联合发起并任主编。
                <br />
                <br />“知识分子”汇聚了科学界一流的专业判断，独树一帜，在众多科学界重大事件，以及社会领域中关切科学的公共事件的相关报道中，成为其他媒体引述的信源，具有极强的传播力和影响力，是科技界公认的头部新媒体平台。
              </p>
            </div>
          </div>
          <div class="main fn-clear">
            <div class="png fr">
              <img src="./../assets/images/-e-unit_zsxys@2x.png" alt />
            </div>
            <div class="contxt fl">
              <p>
                智识学研社由首都医科大学校长饶毅、中国科学技术大学常务副校长潘建伟和清华大学经济管理学院前院长钱颖一，三位知名学者共同发起。
                <br />
                <br />其目标是传播科学知识，从科技出发探索人类命运共同体，打造面向未来的开放的交流平台，介绍国内外科技前沿突破，在公共政策中提供科学家的专业判断，提出驱动未来的科技创新方案，帮助推进科学、技术与创新，促进科学文化在中国逐步建立。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-info fn-clear">
      <div class="tabline fn-clear">
        <div class="fl logowarp">
                <div class="logo">
                  <img class="logo-site logoimg" src="./../assets/images/footer_logo@2x.png" />
                </div>
                <p class="mobile1">
                  <img class="icon" src="./../assets/images/-e-footer_icon_tell.png" /> 010-89738968
                </p>
                <p class="mobile">
                  <img class="icon" src="./../assets/images/-e-footer_icon_mail.png" /> fundamental@zhishifenzi.com
                </p>
                </div>
                <div class="fl link"  style="width:16%">
                  <p class="tit">相关链接</p>
                  <div class="btnlist fn-clear">
                    <p><router-link to="/home">首页</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/guide">申请指南</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/way">管理办法</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/question">常见问题</router-link></p>
                              <p style="margin-top: 10px;"><router-link to="/news">新闻</router-link></p>
                  </div>
                </div>
                <div class="fl etctxt">
                    <p class="tit">联系我们</p>
                  <p class="mobile">
                    <img src="./../assets/images/-e-footer_icon_tell.png" /> 010-89738968
                  </p>
                  <p class="mobile">
                    <img src="./../assets/images/-e-footer_icon_mail.png" /> fundamental@zhishifenzi.com
                  </p>
                </div>
                <div class="fr erweima">
                <img src="./../assets/images/erweima.png" sytle="width:120px;height:120px;"/>
                </div>
      </div>
      <div class="footertxt">
        <p class="copyright">Copyright © 1998 - 2020 ZhiShiFenZi. All Rights Reserved.</p>
        <p class="desctxt"><a href="http://www.51yuqian.cn/" class="desctxt" target="_blank">技术支持：榆钱（北京）科技有限公司</a></p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "./../assets/js/txplayer";
import {getVideoUrl} from "./../config/config.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      androidBrowser: false /* 安卓设备兼容性 */,
      isIE9: false,
      androidLow: false,
      ua: "" /* 设备ua */,
      vedio: "show" /* 视频播放隐藏 */,
      videoPlayer1: "",
      videoimageurl: "",
      menu: false /* 下拉列表显示隐藏 */,
      vid: "y3041rm2jkk" /* 视频参数y3041rm2jkk,c3125qv2w67 */,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    open() {
      // if (this.androidBrowser) dialogVideo.addClass("show");
      this.videoPlayer1.play();
      this.vedio = "hide";
    },
    /* 下拉列表显示隐藏 */
    changemenu() {
      this.menu = !this.menu;
    },
    /* 接口调用demo 
      参考网址：https://www.jianshu.com/p/e36956dc78b8
    */
    vediodemo() {

        this.$http({
         method: "get",
         url: getVideoUrl(),
         params: {},
       }).then(rem => {this.vid=rem.data.data.vid;this.videoimageurl=rem.data.data.img;this.initvideo();});
     },
     initvideo(){
     //$(".vediobox").css("background","#c8ac82 url('"+this.videoimageurl+"') no-repeat top scroll");
     $(".vediobox").css("background","#c8ac82 url('"+this.videoimageurl+"') no-repeat scroll 0 0 transparent");

     this.videoPlayer1 = new Txplayer({
           containerId: this.androidBrowser
             ? "sponsor-video-one"
             : "sponsor-video-one",
           vid: this.vid,
           width: "100%",
           height: "100%",
           playerType: "html5hd",
         });
     }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    /* 页面滚动 */
    $(window).on("scroll", function () {
      var nowScrollTop = $(window).scrollTop();
      if (nowScrollTop > 60 && $(".header").hasClass("opacity"))
        $(".header").removeClass("opacity").addClass("special-header");
      if (
        nowScrollTop <= 60 &&
        !$(".header").hasClass("on") &&
        !$(".header").hasClass("opacity")
      )
        $(".header").addClass("opacity").removeClass("special-header");
    });
    this.ua = window.navigator.userAgent | "";
    if (/Android (\d+\.\d+)/.test(this.ua)) {
      var version = parseFloat(RegExp.$1);
      // 判断6以下安卓
      if (version < 6) {
        this.androidLow = true;
      }
      this.ua = ua.toLowerCase();
      this.androidBrowser = !(ua.match(/MicroMessenger/i) == "micromessenger");
    }
    if (
      navigator.appName == "Microsoft Internet Explorer" &&
      parseInt(
        navigator.appVersion
          .split(";")[1]
          .replace(/[ ]/g, "")
          .replace("MSIE", "")
      ) < 10
    ) {
      this.isIE9 = true;
    }
    //视频初始化
    this.initvideo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  this.vediodemo();
    var _this = this;
    new Swiper(".swiper-container", {
      // direction: "vertical", // 垂直切换选项
      loop: true, // 循环模式选项
      slidesPerView: 1,
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    new Swiper(".swiper-container2", {
      // direction: "vertical", // 垂直切换选项
      loop: true, // 循环模式选项
      slidesPerView: 1,
      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination2",
      },
    });
    //获取元素距离屏幕左边的距离
    var divLeft = document.body.clientWidth;
    console.log(divLeft);
    //获取网页可见区域宽度
    if (divLeft <= 980) {
      console.log(_this.menu);
      if (_this.menu == true) {
        _this.menu = false;
      } else {
        _this.menu = false;
      }
    } else {
      _this.menu = true;
      console.log(_this.menu);
    }
    /* 屏幕宽度变化 */
    window.onresize = function () {
      //获取元素距离屏幕左边的距离
      var divLeft = document.body.clientWidth;
      console.log(divLeft);
      //获取网页可见区域宽度
      if (divLeft <= 980) {
        console.log(_this.menu);
        if (_this.menu == true) {
          _this.menu = false;
        } else {
          _this.menu = false;
        }
      } else {
        _this.menu = true;
        console.log(_this.menu);
      }
    };
    /* 显示隐藏 */
    $(".desc a").on("click", function () {
      $(this).parents(".desc").siblings(".tiptxt").fadeIn();
    });
    $(".tiptxt a").on("click", function () {
      $(this).parents(".tiptxt").fadeOut();
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
@import url("./../assets/css/index2.css");
@import url("./../assets/css/base.css");
</style>